import {useCallback} from 'react';

import {useSetHighlight} from '../../../state/interactState/hooks';

const delay = 200;
let sharedTimer: ReturnType<typeof setTimeout> | undefined;

export function useRunHighlighter(runId: string) {
  const setActive = useSetHighlight();

  const handleMouseOut = useCallback(() => {
    sharedTimer = setTimeout(() => {
      setActive('run:name', undefined);
    }, delay);
  }, [setActive]);

  const handleMouseIn = useCallback(() => {
    setActive('run:name', runId);
    if (sharedTimer) {
      clearTimeout(sharedTimer);
    }
  }, [setActive, runId]);

  return {
    handleMouseIn,
    handleMouseOut,
  };
}
